const polyfill: Pick<ErrorConstructor, 'isError'> = {
  isError(obj): obj is Error {
    switch (Object.prototype.toString.call(obj)) {
      case '[object Error]': // errors
      case '[object Exception]': // sentry
      case '[object DOMException]': // browsers
      case '[object DOMError]': // browsers, deprecated
        return true;
    }

    try {
      return obj instanceof Error;
    } catch {
      return false;
    }
  },
};

if (!Error.isError || (typeof DOMException === 'function' && !Error.isError(new DOMException()))) {
  Error.isError = polyfill.isError;
}

export { polyfill };
